import React from 'react';
import { IProduct } from '../../../types';
import './ProductPushElement.scss';

import withPriceData, { IInjectedPriceProps } from "../../../hoc/withPriceData";

interface IProductPushPriceProps extends IInjectedPriceProps {
  product: IProduct;
}

const ProductPushPrice = ({ priceData }: IProductPushPriceProps) => {
  return <span className="price">{priceData.price}</span>;
};

export default withPriceData(ProductPushPrice);
